import {Route, Routes, Outlet, useSearchParams, Navigate, useParams} from 'react-router-dom'
import {BarberShopWrapper} from './BarberShopWrapper'
import StylistListPage from './stylist-page/StylistPage'
import CatalogueListPage from './stylist-catalogue/StylistCatalogue'
import {FC, createContext, useEffect, useState} from 'react'
import {PageWrapper} from '../PageWrapper'
import {KTSVG} from '../../../_metronic/helpers'
import {FetchModal} from './fetch-modal/FetchModal'
import {ReviewModal} from './review-modal/ReviewModal'

const BarberShopPage = () => {
  const [searchParams] = useSearchParams()
  const session_id = searchParams.get('session_id')
  const [show, setShow] = useState(false)
  useEffect(() => {
    if (session_id) setShow(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session_id])

  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route index element={<BarberShopWrapper />} />
          <Route path='review/:id/*' element={<Review />} />
          <Route element={<PageWrapper />}>
            <Route path='services' element={<CatalogueListPage />} />
            <Route path='staffs' element={<StylistListPage />} />
          </Route>
        </Route>
        <Route path='*' element={<Navigate to='' />} />
      </Routes>
      {show && <SuccessModal setShow={setShow} />}
    </>
  )
}

export default BarberShopPage

const SuccessModal: FC<{setShow: any}> = ({setShow}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block modal-md'
        id='kt_modal_add_location'
        role='dialog'
        tabIndex={-1}
        // aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered'>
          {/* begin::Modal content */}
          <div className='modal-content bg-light'>
            {/* begin::Modal body */}
            <div className='modal-body scroll-y my-7 m-auto text-center'>
              <KTSVG
                path='/media/icons/duotune/general/gen043.svg'
                className='svg-icon-success svg-icon-5hx'
              />
              <div className='my-10 fs-4'>
                You have successfully make an appointment booking. <br />
                Please, check your email for further instructions
                <button
                  className='btn btn-primary btn-sm d-block m-auto my-10'
                  onClick={() => setShow(false)}
                >
                  Back to Store
                </button>
              </div>
              {/* <POS defaultData={defaultData} /> */}
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}
export const BookingContext = createContext<{
  id?: string
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  setReviewShow: React.Dispatch<React.SetStateAction<boolean>>
}>({setShow: () => {}, setReviewShow: () => {}})

const Review = () => {
  const {id} = useParams()
  const [show, setShow] = useState(!!id)
  const [showReview, setReviewShow] = useState(false)
  return (
    <>
      {show && (
        <BookingContext.Provider value={{id, setShow, setReviewShow}}>
          <FetchModal />
          {showReview && <ReviewModal />}
        </BookingContext.Provider>
      )}
      <BarberShopPage />
    </>
  )
}
